import React from 'react'
import dayjs from '../../../utils/date'
import { useDataSelector } from '../../helpers/selectors'
import { Card } from '../../../atoms'

interface IAuthorEditorDetails {
  authorName: string
  authorPageUrl: string
  editorName: string
  editorPageUrl: string
  factCheckerName?: string
  factCheckerPageUrl?: string
  lastUpdated: string
}

interface IAuthorEditorCardProps {
  name: string
  jsonBody: IAuthorEditorDetails
}

const AuthorEditorCard = ({ jsonBody, name }: IAuthorEditorCardProps) => {
  const {
    authorName,
    authorPageUrl,
    editorName,
    editorPageUrl,
    factCheckerName,
    factCheckerPageUrl,
  } = jsonBody

  const lastUpdatedOld = useDataSelector(['rootEntity', 'fields', 'updatedDate'])
  const lastUpdated = dayjs(lastUpdatedOld).format('MMMM Do, YYYY')

  try {
    return (
      <div className='AuthorEditor' id={name}>
        <Card variant='modal'>
          <div className='AuthorEditor__Details'>
            <div className='AuthorEditor__DetailsSection'>
              <div className='AuthorEditor__DetailsLabel'>Author</div>
              <div className='AuthorEditor__DetailsValue'>
                <a href={authorPageUrl}>{authorName}</a>
              </div>
            </div>
            {editorName && editorPageUrl && (
              <div className='AuthorEditor__DetailsSection'>
                <div className='AuthorEditor__DetailsLabel'>Editor</div>
                <div className='AuthorEditor__DetailsValue'>
                  <a href={editorPageUrl}>{editorName}</a>
                </div>
              </div>
            )}
            {factCheckerName && factCheckerPageUrl && (
              <div className='AuthorEditor__DetailsSection'>
                <div className='AuthorEditor__DetailsLabel'>Fact checker</div>
                <div className='AuthorEditor__DetailsValue'>
                  <a href={factCheckerPageUrl}>{factCheckerName}</a>
                </div>
              </div>
            )}
            <div className='AuthorEditor__DetailsSection'>
              <div className='AuthorEditor__DetailsLabel'>Last updated</div>
              <div className='AuthorEditor__DetailsValue AuthorEditor__DetailsLastUpdated'>
                {lastUpdated}
              </div>
            </div>
          </div>
        </Card>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default AuthorEditorCard
